<template>
  <div v-if="costingline">
    <div class="row row-epic-heading">
      <div class="col-5 epic-heading line-heading">
        <div class="row">
          <div class="col-8">
            <div class="move-epic">
              <i class="fa fa-grip-lines dragEpic drag_handle"></i>
            </div>
            <input v-model="stateEpicTitle" @blur="leftFocus" type="text" class="form-control epic-title" :disabled="isDisabled" />
          </div>
          <div class="col-4 text-end">
            <multiselect
              v-model="tag"
              :options="stages"
              placeholder="none"
              :showLabels="false"
              class="stage-select"
              label="text"
              track-by="id"
              @select="stageSelected"
              :disabled="isDisabled"
            ></multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="padding-left: 38px;">
            <!-- <div
              v-show="!focus"
              v-html="epic.description"
              v-on:click="!isSigned ? (focus = true) : null"
              style="min-height:40px;"
            ></div> -->
            <wysiwyg-inline
              :content="epic.description"
              :save="saveEpicDescription"
              :blur="blur"
            ></wysiwyg-inline>
          </div>
        </div>
      </div>
      <div class="col flex-cell"></div>
      <div class="col flex-cell"></div>
      <div class="col flex-cell text-strong">
        <!-- <span class="d-block text-end w-100 total-hours">{{ costingline.hours }}</span> -->
      </div>
      <div class="col flex-cell adjustment">
        <div class="input-group input-adjustment">
          <!--<div class="input-group-addon">$</div>
           <input
            type="text"
            v-model="adjustment"
            @blur="updateAdjustment"
            placeholder="0"
            class="form-control width-md"
            :disabled="isDisabled"
          /> -->
        </div>
      </div>
      <div class="col flex-cell cost">
        <!-- <div class="w-100 text-end">${{ costingline.total_ex | currency }}</div> -->
      </div>
      <div class="col-1 options">
        <div class="dropdown" v-if="!isSigned">
          <button
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
            class="btn btn-light"
          >
            <i class="fa fa-ellipsis-h"></i>
          </button>
          <div aria-labelledby="dropdownMenu1" class="dropdown-menu">
            <a href="#" class="dropdown-item" @click="confirmDelete">Delete</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-line-item">
      <div class="col-5 line-heading">
        <div class="row">
          <div class="col-1"></div>
        <div class="col-4">
          <span class="area-title text-start">Deliverable</span>
        </div>
        <div class="col-7">
          <span class="area-title text-start">Description</span>
        </div>
      </div>
    </div>
    <div class="col flex-cell">
      <span class="area-title text-start">Display</span>
    </div>
    <div class="col flex-cell">
      <span class="area-title text-start">Unit Time</span>
    </div>
    <div class="col flex-cell"></div>
    <div class="col flex-cell">
      <span class="area-title text-end"><strong>Cost</strong></span>
    </div>
    <div class="col-1 options"></div>
  </div>

    <draggable
      v-model="stateUserStories"
      class="dragArea"
      :options="{ group: 'stories', ghostClass: 'ghost-class', handle: '.drag', disabled: isSigned }"
      @update="storiesReordered(epic.id)"
      @add="storiesAdded(epic.id)"
    >
      <user-story
        v-for="(userstory, storyIndex) in epic.stories"
        :key="userstory.id"
        :costingline="getLineByStoryId(userstory.id)"
        :userstory="userstory"
        :epic="epic"
        :parent-order="order"
        :epicIndex="index"
        :storyIndex="storyIndex"
      ></user-story>
    </draggable>

    <div class="row row-line-item row-line-totals">
      <div class="col-5 line-heading">
        <input
          type="text"
          v-model="newUserStory.title"
          class="form-control text-start"
          placeholder="Add Deliverable..."
          @blur="handleCreateUserStory"
          v-on:keyup.enter="handleCreateUserStory"
          :disabled="isDisabled"
          v-if="!isSigned"
        />
      </div>
      <div class="col-7">
        <div class="row row-line-item">
          <div class="col flex-cell"></div>
          <div class="col flex-cell"><span class="text-start">{{ costingline.hours }}&nbsp;<span>hrs</span></span></div>
          <div class="col flex-cell"><span class="area-title text-end">Adjustment:</span></div>
          <div class="col flex-cell">
            $
            <input
              type="text"
              v-model="adjustment"
              @blur="updateAdjustment"
              placeholder="0"
              class="form-control width-md text-end"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-1 options"></div>
        </div>
        <div class="row row-line-item">
          <div class="col flex-cell"></div>
          <div class="col flex-cell"></div>
          <div class="col flex-cell"><span class="area-title text-end">License:</span></div>
          <div class="col flex-cell">
            $
            <input
              type="text"
              v-model="license"
              @blur="updateLicense"
              placeholder="0"
              class="form-control width-md text-end"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-1 options"></div>
        </div>
        <div class="row row-line-item">
          <div class="col flex-cell"></div>
          <div class="col flex-cell"></div>
          <div class="col flex-cell"><span class="area-title text-end">Total:</span></div>
          <div class="col flex-cell cost"> <div class="w-100 text-end">${{ costingline.total_ex | currency }}</div></div>
          <div class="col-1 options"></div>
        </div>
      </div>
      
    </div>


  </div>
</template>

<script>
import { notify } from 'utils'
import { filters } from 'mixins'
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'
import { SET_SAVE_STATUS } from 'vx/mutations'
import { WysiwygInline } from 'components/form/input'
import AppConstants from '@/support/app-constants'
import { filter, findIndex, intersectionBy } from 'lodash'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

import UserStory from 'components/opportunities/user-stories/UserStory.vue'

var Story = require('./../../../models/story.js')

export default {
  mixins: [filters],

  props: ['initialEpic', 'index', 'costingline'],

  components: {
    draggable,
    UserStory,
    WysiwygInline,
    Multiselect,
  },

  data() {
    return {
      epic: this.initialEpic,
      newUserStory: new Story(),
      adjustment: this.costingline ? this.costingline.adjustment : null,
      license: this.costingline ? this.costingline.license : null,
      stages: [
        { id: 1, text: 'Stage 1' },
        { id: 2, text: 'Stage 2' },
        { id: 3, text: 'Stage 3' },
      ],
      focus: false,
    }
  },

  mounted() {
    this.onDeleteUserStory = id => {
      if (this.epic.id === id) {
        this.storiesReordered(this.epic.id)
      }
    }

    this.$bus.$on('delete-user-story', this.onDeleteUserStory)
  },

  beforeDestroy() {
    this.$bus.$off('delete-user-story', this.onDeleteUserStory)
  },

  computed: {
    //...mapState('project', ['project']),
    ...mapState('costing', ['costing']),
    ...mapState('epics', ['epics']),
    ...mapState('opportunity', {
      opportunity: 'single',
    }),
    ...mapGetters('costing', ['getLineByEpicId', 'getLineByStoryId']),
    ...mapGetters('opportunity', ['isSigned']),

    isDisabled() {
      return this.isSigned || this.opportunity.approved_at != null
    },

    tag: {
      get() {
        if (this.epic.tags.length) {
          return this.epic.tags[0]
        }

        return null
      },
    },

    getAdjustment: {
      get() {
        if (this.costingline) {
          return this.costingline.adjustment
        }
      },
    },

    order() {
      return this.index + 1
    },

    stateEpicTitle: {
      get() {
        return this.epics[this.index].title
      },

      set(value) {
        this.setEpicProperty({ property: `epics.${this.index}.title`, value })
      },
    },

    stateUserStories: {
      get() {
        return this.epic.stories
      },

      set(value) {
        this.setUserStories({ epicId: this.epic.id, userstories: value })
      },
    },
  },

  methods: {
    ...mapMutations('settings/app', [SET_SAVE_STATUS]),
    ...mapActions('epics', [
      'addUserStory',
      'setUserStories',
      'setEpicProperty',
      'deleteEpic',
      'reorderUserStories',
      'updateEpic',
      'setTag',
    ]),
    ...mapActions('costing', ['updateCostingLine']),

    saveEpicDescription(data) {
      //Update the local state, its not reloaded between tabs
      this.setEpicProperty({ property: `epics.${this.index}.description`, value: data })

      return client({
        path: '/user-story-document/' + this.costing.user_story_document_id + '/epics/' + this.epic.id,
        entity: { title: this.epic.title, order: this.epic.order, description: data },
        method: 'PUT',
      })
      //Would use this but it breaks the ordering of userstories the after saved then move userstory twice
      //return this.updateEpic({docId: this.epic.user_story_document_id, epicId:this.epic.id, payload:{title: this.epic.title, order: this.epic.order, description: data}})
    },

    stageSelected(tag) {
      return client({
        path: '/user-story-document/' + this.costing.user_story_document_id + '/epics/' + this.epic.id,
        entity: { title: this.epic.title, order: this.epic.order, tag: tag },
        method: 'PUT',
      }).then(() => {
        this.setTag({ epic: this.epic, tag: tag })
      })
    },

    confirmDelete() {
      this.$swal({
        title: 'Confirm Delete',
        html:
          'Are you sure you want to delete EP #' +
          this.order +
          '?<br> this will delete all of the user stories under it.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then(
        () => {
          this.handleDeleteEpic()
        },
        function() {}
      )
    },

    handleDeleteEpic() {
      this.$status.$emit('saving')

      return this.deleteEpic({
        // Use the epic's own document - costing state can be stale mid-navigation
        docId: this.epic.user_story_document_id,
        epicId: this.epic.id,
      })
        .then(response => {
          this.$emit('deleted', this.epic.id)
          this.$status.$emit('saved')
        })
        .catch(response => {
          if (response.status.code == 422) {
            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]]

            notify.error(firstValidationIssue)
            this.$status.$emit('dirty')
          } else {
            this.$status.$emit('error')
          }
        })
    },

    leftFocus() {
      var that = this
      this.$status.$emit('saving')

      return client({
        path: '/user-story-document/' + this.costing.user_story_document_id + '/epics/' + this.epic.id,
        entity: this.epic,
        method: 'PUT',
      }).then(
        response => {
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
        },
        response => {
          if (response.status.code == 422) {
            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]]

            notify.error(firstValidationIssue)
            this.$status.$emit('dirty')
          } else {
            this.$status.$emit('error')
          }
        }
      )
    },

    updateAdjustment(value) {
      this.updateCostingLine({
        userStoryDocumentId: this.costing.user_story_document_id,
        costingId: this.costing.id,
        lineId: this.costingline.id,
        payload: {
          adjustment: this.adjustment,
        },
      }).then(() => {
        this.$bus.$emit('updateCosting')
      })
    },
    updateLicense(value) {
      this.updateCostingLine({
        userStoryDocumentId: this.costing.user_story_document_id,
        costingId: this.costing.id,
        lineId: this.costingline.id,
        payload: {
          license: this.license,
        },
      }).then(() => {
        this.$bus.$emit('updateCosting')
      })
    },
    getEpic(epicId) {
      return this.epics.find(x => x.id === epicId)
    },

    storyOrderArray(epicId) {
      var storyOrderArray = []
      var epic = this.getEpic(epicId)
      var stories = epic.stories

      for (var i = 0; i < stories.length; i++) {
        var story = stories[i]
        storyOrderArray.push({ id: story.id })
      }

      return { stories: storyOrderArray }
    },

    handleCreateUserStory() {
      if (this.newUserStory.title == '') return

      this.$status.$emit('saving')
      this.newUserStory.epic_id = this.epic.id

      this.addUserStory({
        id: this.costing.user_story_document_id,
        payload: Object.assign(this.newUserStory, { complexity: 1 }),
      })
        .then(response => {
          this.$bus.$emit('updateCosting')
          this.newUserStory = new Story()
          this.$status.$emit('saved')
        })
        .catch(error => {
          this.$status.$emit('error')
        })
    },

    saveUserStoryOrder(epicId) {
      var that = this
      var stories = this.epics.find(x => x.id === epicId).stories
      this.$status.$emit('saving')

      this.reorderUserStories({
        id: this.epic.id,
        payload: this.storyOrderArray(this.epic.id),
      })
        .then(response => {
          this.$status.$emit('saved')
          this.$bus.$emit('updateCosting')
        })
        .catch(response => {
          this.$status.$emit('error')
        })
    },

    storiesReordered(epicId) {
      this.saveUserStoryOrder(epicId)
    },

    storiesAdded(epicId) {
      this.saveUserStoryOrder(epicId)
    },

    blur() {
      this.focus = false
    },
  },
}
</script>

<style scoped>
i.rotate {
  transform: rotate(180deg);
}

.dragArea .story-drop {
  min-height: 50px;
}

.ghost-class .user-story {
  opacity: 0.2;
  border: 2px dashed #000;
}

.ghost-class .epic-heading {
  opacity: 0.2;
  border: 2px dashed #000;
}

.form-control {
  text-align: left;
}

.epic-heading .ck-content {
  font-size: 14px;
}

.epic-heading input.epic-title {
  text-align: left;
}

.move-epic {
  margin-right: 10px;
}

.epic-heading .multiselect {
  font-size: 12px;
}

.stage-costing .epic-heading .move-epic {
  top: 10px;
}

.stage-select {
  width: 100px;
  display: inline-block;
}

.stage-costing .epic-heading .drag_handle {
  font-size: 16px;
  color: #ccc;
  position: absolute;
  left: 16px;
  top: 18px;
}

.stage-costing .epic-heading .epic-title {
  font-weight: 500;
}

.stage-costing .row-epic-heading {
  font-weight: 400;
}

.stage-costing .row-line-totals {
  line-height: 46px;
}

.stage-costing .line-totals-heading {
    position: relative;
    padding-left: 2.5rem;
    padding-top: 4px;
    padding-bottom: 4px;
    -webkit-box-shadow: 6px 0 6px -3px rgba(0, 0, 0, 0.08);
    box-shadow: 6px 0 6px -3px rgba(0, 0, 0, 0.08);
    min-width: 18rem;
}






</style>

<style>
.stage-select .multiselect__single,
.stage-select .multiselect__input {
  font-size: 12px !important;
}

.stage-select div.multiselect .multiselect__tags {
  border-bottom: 0px;
}
</style>
